module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.wood.co2.flux.3583f2a7.png").toString();